import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import EquipmentOrToolsTypesContext from '../../../context/EquipmentOrToolsTypes/EquipmentOrToolsTypesContext'
import { Spinner } from 'reactstrap';
import CustomPagination from '../../CustomPagination/CustomPagination';
import { EmptyStateOne } from '../../Empty/EmptyStateOne';
import { Searcher } from '../Searcher';
import { EquipmentOrToolType } from './EquipmentOrToolType';
import { getCurrentItems } from '../../../helpers/helpers';
import useWindowSize from '../../../customHooks/useWindowSize';
import { AlertModal } from '../AlertModal';
import successIcon from '../../../assets/icons/equiptment-success.icon.svg'
import errorIcon from '../../../assets/icons/equiptment-error-icon.svg'

const EquipmentOrToolsTypes = () => {

  const { windowWidth } = useWindowSize()

  const { equipmentOrToolsTypesState, getEquipmentOrToolsTypes, setTypes, setError, setAlert } = useContext(EquipmentOrToolsTypesContext);

  const { types, isFetching, error, errorMessage, alert, alertMessage, typesSearcheable, } = equipmentOrToolsTypesState;

  const [pageNumber, setPageNumber] = useState(1);

  const itemsPerPage = 5;

  const currentTypes = getCurrentItems(types, pageNumber, itemsPerPage)

  const totalPages = Math.ceil(types.length / itemsPerPage);

  const searchTypes = ({ target }) => {
    const { value } = target
    const typesResult = typesSearcheable.filter(typeSearcheable => typeSearcheable.equipmentDescription.trim().toLowerCase().includes(value))
    setTypes(typesResult);
  }

  useEffect(() => {
    getEquipmentOrToolsTypes();
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {error && (
        <AlertModal
          showModal={error}
          onClose={() => setError(false)}
          message={errorMessage}
          icon={errorIcon}
        />
      )}
      {alert && (
        <AlertModal
          showModal={alert}
          onClose={() => {
            setAlert(false)
            getEquipmentOrToolsTypes()
          }}
          message={alertMessage}
          icon={successIcon}
        />
      )}
      <div className='h-100 d-flex justify-content-between flex-column'>
        <div className='h-100'>
          <div>
            <Searcher
              name={'equipmentOrToolsMaganagement'}
              navigateToCreate={'equipmentOrToolsMaganagement'}
              nameOfEntity={t('TYPE_EQUIPMENT_OR_TOOLS')}
              onChange={searchTypes}
            />
          </div>
          <div className='mt-4'>
            {isFetching && (
              <div className="d-flex justify-content-center align-items-center">
                <Spinner />
              </div>
            )}
            {(!isFetching && currentTypes.length === 0) && (
              <EmptyStateOne />
            )}
            {!isFetching && (
              <div
                className="d-flex flex-column gap-2 no-show-scroll"
                style={{
                  maxHeight: windowWidth > 567 ? '500px' : '450px',
                  overflowX: 'auto'
                }}
              >
                {currentTypes.map(type =>
                  <EquipmentOrToolType
                    key={type.equipmentTypeId}
                    {...type}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center pb-5">
          <CustomPagination
            totalPages={totalPages}
            page={pageNumber}
            setPage={setPageNumber}
            disabled={isFetching}
          />
        </div>
      </div>
    </>
  )
}

export default EquipmentOrToolsTypes